<template>
    <div class="snackbar" id="c2b-new-update-snackbar">
        <div class="snackbar-message">
           <p>Atualização disponível</p> 
        </div>

        <div class="snackbar-action">
            <button type="button" 
                class="btn btn-outline-primary" 
                @click="update()">
                Atualizar
            </button>            
        </div>
    </div>
</template>

<script>
import newUpdateService from '../services/NewUpdateService'

export default {
    name: 'NewUpdateCmp',    
    methods: {
        update() {
            window.location.reload()
        },
        close() {
            newUpdateService.hide()
        },
    },
}
</script>

<style lang="scss" scoped>
.snackbar {
    position: fixed;
    bottom: -100px;
    right: 15px;
    padding: 8px;
    background-color: #3f3f3f;    
    border-radius: 4px;
    z-index: 1;
    padding: 8px 15px;
    transition: bottom .3s ease;

    .snackbar-message {
        color: #f9f9f9;
        width: 250px;
        float: left;
        padding-top: 5px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 1px;

        p {
            margin-bottom: 0;
        }
    }

    .snackbar-action {
        float: right;
        
        .btn {
            background-color: #eceeef;

            &.btn-outline-primary {
                border: none;
            }
            
            &.btn-outline-secondary {
                border: none;               
            }
        }
    }

    @media(min-width: 992px) {
        max-width: 400px;
        bottom: -100px;

        &.active {
            bottom: 15px;
        }

        .snackbar-message {
            color: #f9f9f9;
            float: left;
        }

        .snackbar-action {
            float: right;
            text-align: right;
        }
    }        
}
</style>
